module.exports = __webpack_public_path__ + "img/icon32-phone-volume-primary.83bf83ee.svg";